module.exports = __webpack_public_path__ + "static/media/icon_nav_users.21b17810.svg";